import React, { useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink } from "react-router-dom";

const TEAL = "#06b6a4";

const COLUMNS = [
  { key: "soa", label: "SOA", sort: false, search: false },
  { key: "folio", label: "Folio", sort: true, search: true },
  { key: "scheme_name", label: "Scheme Name", sort: true, search: true },
  { key: "investor_folio", label: "Investor (Folio)", sort: true, search: true },
  { key: "investor_mapped", label: "Investor (Mapped To)", sort: true, search: true },
  { key: "pan", label: "PAN", sort: true, search: true },
  { key: "amount", label: "Amount", sort: true, search: false, highlight: true },
  { key: "comment", label: "Comment", sort: false, search: true },
  { key: "folio_type", label: "Folio type", sort: true, search: false },
];

function ThCell({ col }) {
  const isHighlight = col.highlight;
  const thStyle = {
    padding: "12px 16px",
    color: "#334155",
    fontWeight: "600",
    fontSize: "13px",
    whiteSpace: "nowrap",
    background: isHighlight ? "#ecfdf5" : "#f8fafc",
    borderBottom: "1px solid #e2e8f0",
    borderLeft: isHighlight ? `3px solid ${TEAL}` : undefined,
    verticalAlign: "middle",
  };
  return (
    <th style={thStyle}>
      {col.label}
      {col.sort && (
        <i className={`fa fa-sort${isHighlight ? "-down" : ""} ms-1 opacity-75`} style={{ fontSize: "10px" }} aria-hidden />
      )}
      {col.search && (
        <i className="fa fa-search ms-1 opacity-75" style={{ fontSize: "10px" }} aria-hidden />
      )}
    </th>
  );
}

export default function MyFolios() {
  const [showAllFolios, setShowAllFolios] = useState(true); // true = Show All Folios, false = Show Active Folios
  const [folioData, setFolioData] = useState([]);

  const handleExportXls = () => {
    // TODO: export to XLS
  };

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9", minHeight: "100vh" }}>
        {/* Header */}
        <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
          <div className="card-body p-4">
            <h3 className="text-primary mb-2">My Folios</h3>
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none" }}>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <NavLink to="/overview">Dashboard</NavLink> /
                </li>
                {/* <li className="breadcrumb-item">
                  <NavLink to="/clientmutualfunds">Mutual Funds</NavLink> /
                </li> */}
                <li className="breadcrumb-item active" aria-current="page">My Folios</li>
              </ol>
            </nav>
          </div>
        </div>

        {/* Main card: toggle + table */}
        <div className="card shadow-sm border-0" style={{ borderRadius: "12px", border: "1px solid #e2e8f0", overflow: "hidden" }}>
          <div className="card-header d-flex justify-content-between align-items-center py-3 px-4 bg-white border-bottom">
            <div className="d-flex align-items-center gap-2">
              <span style={{ fontSize: "14px", color: "#64748b", fontWeight: "500" }}>Show Active Folios</span>
              <div className="form-check form-switch mb-0">
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={showAllFolios}
                  onChange={() => setShowAllFolios(!showAllFolios)}
                  style={{ width: 40, height: 20, accentColor: TEAL, cursor: "pointer" }}
                />
              </div>
              <span style={{ fontSize: "14px", color: "#64748b", fontWeight: "500" }}>Show All Folios</span>
            </div>
            <button
              type="button"
              className="btn btn-sm d-flex align-items-center gap-1"
              onClick={handleExportXls}
              title="Export Excel"
              style={{ color: TEAL, border: `1px solid ${TEAL}`, borderRadius: "8px", fontWeight: "600" }}
            >
              <i className="fa fa-file-excel" aria-hidden />
              XLS
              <i className="fa fa-download ms-1" style={{ fontSize: "0.7rem" }} aria-hidden />
            </button>
          </div>
          <div className="table-responsive">
            <table className="table table-hover mb-0">
              <thead>
                <tr>
                  {COLUMNS.map((col) => (
                    <ThCell key={col.key} col={col} />
                  ))}
                </tr>
              </thead>
              <tbody style={{ background: "#fff" }}>
                {folioData.length === 0 ? (
                  <tr>
                    <td colSpan={COLUMNS.length} className="text-center py-5" style={{ color: "#64748b" }}>
                      <i className="fa fa-exclamation-triangle d-block mb-2" style={{ fontSize: "2rem", color: "#f59e0b" }} aria-hidden />
                      No data available.
                    </td>
                  </tr>
                ) : (
                  folioData.map((row, idx) => (
                    <tr key={idx}>
                      <td style={{ padding: "12px 16px" }}>{row.soa}</td>
                      <td style={{ padding: "12px 16px" }}>{row.folio}</td>
                      <td style={{ padding: "12px 16px" }}>{row.schemeName}</td>
                      <td style={{ padding: "12px 16px" }}>{row.investorFolio}</td>
                      <td style={{ padding: "12px 16px" }}>{row.investorMappedTo}</td>
                      <td style={{ padding: "12px 16px" }}>{row.pan}</td>
                      <td style={{ padding: "12px 16px" }}>{row.amount != null ? `₹ ${Number(row.amount).toLocaleString()}` : ""}</td>
                      <td style={{ padding: "12px 16px" }}>{row.comment}</td>
                      <td style={{ padding: "12px 16px" }}>{row.folioType}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
